/**
 * URL parameter utilities.
 * Assigned to window for use by page-level templates.
 *
 * Note: setUrlParameter and removeUrlParameters are currently stub functions
 * (their implementations are commented out in the original source).
 * They are kept here as window globals to avoid breaking any callers,
 * but their bodies should be completed when URL state management is implemented.
 */

function getUrlParameter(sParam) {
  const sPageURL      = window.location.search.substring(1);
  const sURLVariables = sPageURL.split('&');

  for (let i = 0; i < sURLVariables.length; i++) {
    const sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

function setUrlParameter(key, val) {
  // TODO: implement URL state management
    console.log(key, val);
}

function removeUrlParameters() {
}

export function initUrlUtils() {
  window.getUrlParameter    = getUrlParameter;
  window.setUrlParameter    = setUrlParameter;
  window.removeUrlParameters = removeUrlParameters;
}



// WEBPACK FOOTER //
// ./scripts/utils/url.js